export const SET_ETID = 'SET_ETID';
export const SET_FOREIGN = 'SET_FOREIGN';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_ISLOGIN = 'SET_ISLOGIN';
export const SET_ISDISNEY = 'SET_ISDISNEY';
export const SET_ISGDS = 'SET_ISGDS';
export const SET_ISERPORDER = 'SET_ISERPORDER';
export const SET_FOCUSAREA = 'SET_FOCUSAREA';
export const SET_LISTSTATUS = 'SET_LISTSTATUS';
export const SET_LISTDATA = 'SET_LISTDATA';
// export const SET_DETAILFETCHDATA = 'SET_DETAILFETCHDATA';
export const SET_DETAILFETCHALLDATA = 'SET_DETAILFETCHALLDATA';
export const SET_DETAILFETCHMONTHS = 'SET_DETAILFETCHMONTHS';
export const SET_DETAILFETCHFAILMSG = 'SET_DETAILFETCHFAILMSG';
export const SET_VERIFICATIONSTATUS = 'SET_VERIFICATIONSTATUS';
export const SET_PRODUCTDESCKEY = 'SET_PRODUCTDESCKEY';
// 自建
export const SET_ISTDETAILCROSSLOADING = 'SET_ISTDETAILCROSSLOADING';
// GDS
export const SET_GLISTDATA = 'SET_GLISTDATA';
export const SET_GDETAILSTORE = 'SET_GDETAILSTORE';
